<div class="rating" [style.--percent]="getPercent()" (mouseenter)="onMouseOver($event)"
    (mousemove)="onMouseOver($event)" (mouseout)="onMouseOut()" (click)="saveRating()">
</div>